import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function SelectCity({api, setApi}) {
    const handleChange = (event) => {
        setApi(event.target.value);
    };

    return (
        <div>
            <FormControl variant="filled" sx={{ m: 1, minWidth: 120 }}>
                <InputLabel style={{color: 'white'}} id="demo-simple-select-filled-label">City</InputLabel>
                <Select
                    labelId="demo-simple-select-filled-label"
                    id="demo-simple-select-filled"
                    value={api}
                    onChange={handleChange}
                    style={{color: 'white'}}
                >
                    <MenuItem value={'https://api.openweathermap.org/data/2.5/weather?lat=26.8206&lon=30.8025&appid=012ef46892a7d01fbeb3b810ef8f55ee'}>Egypt</MenuItem>
                    <MenuItem value={'https://api.openweathermap.org/data/2.5/weather?lat=24.774265&lon=46.738586&appid=012ef46892a7d01fbeb3b810ef8f55ee'}>riyadh</MenuItem>
                    <MenuItem value={'https://api.openweathermap.org/data/2.5/weather?lat=33.589886&lon=-7.603869&appid=012ef46892a7d01fbeb3b810ef8f55ee'}>morocco</MenuItem>
                </Select>
            </FormControl>
        </div>
    );
}
